import Svg, { Circle, G, Path } from 'react-native-svg'
const BluetoothIcon = ({ width, height }) => (
  <Svg width={width} height={height} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <Circle cx={50} cy={50} r={48} fill="white" stroke="#c0c0c0" strokeWidth={0.5} />
    <G stroke="#DF9F39" strokeWidth={4} fill="none" strokeLinecap="round" strokeLinejoin="round">
      <Path d="M50 35 L50 65" />
      <Path d="M38 42.5 L62 57.5" />
      <Path d="M38 57.5 L62 42.5 L50 35" />
      <Path d="M50 65 L62 57.5" />
      <Circle cx={30} cy={50} r={3} fill="#DF9F39" stroke="none" />
      <Circle cx={70} cy={50} r={3} fill="#DF9F39" stroke="none" />
    </G>
  </Svg>
)
export default BluetoothIcon
